import React from 'react';
/* --- import Components ----*/
import { Paragraph, SectionSubtitle } from '../Typography';
import SocialProof from './SocialProof';
import { BulletsPoints } from '../CorporateCourses';
import { TagContainer } from '../Tags/elements';
import Tag from '../Tags/Tag';
/* --- import Styles and Images ----*/
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';
import LogoLeReacteurLanding from '../Logo/LogoLeReacteurLanding';

const HeroText = ({ fromPage }) => {
  const program = [
    {
      page: 'reunion',
      details: {
        title: 'Apprenez à coder\u00A0!',
        socialProof: [
          { number: '2000+', text: 'élèves formés' },
          { number: '4,9/5', text: 'selon les élèves' },
        ],
      },
    },
    {
      page: 'rncp5-e-learning',
      details: {
        title: `Apprenez\u00A0à\u00A0coder à\u00A0votre\u00A0rythme, depuis\u00A0chez\u00A0vous\u00A0!`,
        tags: ['diplômant bac+2', 'e-learning', 'Mentoring'],
        socialProof: [
          { number: '2000+', text: 'élèves formés' },
          { number: '4,9/5', text: 'selon les élèves' },
        ],
        bullets: [
          '3 à 6 mois de formation en e-learning + mentoring',
          '4 mentors à disposition',
          '3.400€ pour les particuliers',
          'co-financement par France Travail',
        ],
      },
    },
    {
      page: 'rncp6-fullTime',
      details: {
        title: `Apprenez\u00A0à\u00A0coder pendant 10\u00A0semaines\u00A0intensives\u00A0!`,
        tags: [
          'diplômant\u00A0bac+3/4',
          'web+mobile',
          'sur\u00A0place\u00A0ou\u00A0à\u00A0distance',
        ],
        socialProof: [
          { number: '2000+', text: 'élèves formés' },
          { number: '4,9/5', text: 'selon les élèves' },
        ],
        bullets: [
          '400h de formation en\u00A0présentiel ou à\u00A0distance',
          '4 mentors à disposition',
          'titre RNCP niveau 6 (Bac +3/4)',
          'nombreuses options de\u00A0financement',
        ],
      },
    },
    {
      page: 'rncp6-partTime',
      details: {
        title: `Apprenez\u00A0à\u00A0coder en\u00A06\u00A0mois, sans\u00A0quitter\u00A0votre\u00A0emploi\u00A0!`,
        tags: ['diplômant\u00A0bac+3/4', 'web+mobile', 'à\u000Adistance'],
        socialProof: [
          { number: '2000+', text: 'élèves formés' },
          { number: '4,9/5', text: 'selon les élèves' },
        ],
        bullets: [
          '400h de formation à\u00A0distance',
          'mardi et jeudi soirs de 19h à 22h et samedi de 10h à 18h',
          'titre RNCP niveau 6 (Bac +3/4)',
          '7.000€ (financement perso et/ou CPF) ou 9.000€ HT (entreprises, OPCO, Trans. Pro)',
          'nombreuses options de\u00A0financement',
        ],
      },
    },
    {
      page: 'rncp6-alternance',
      details: {
        title: `L’alternance, vous y avez pensé\u00A0? Apprenez à coder en\u00A0étant\u00A0rémunéré\u00A0!`,
        tags: [
          'diplômant\u00A0bac+3/4',
          'web+mobile',
          'sur\u00A0place\u00A0ou\u00A0à\u00A0distance',
        ],
        socialProof: [
          { number: '2000+', text: 'élèves formés' },
          { number: '4,9/5', text: 'selon les élèves' },
        ],
        bullets: [
          '721h de formation',
          'titre RNCP niveau 6 (Bac +3/4)',
          '0 frais et rémunération selon profil',
          'contrat d’apprentissage ou de professionnalisation',
        ],
      },
    },
  ];

  const programFiltered = program.filter((program) => program.page === fromPage)[0].details;
  return (
    <div
      css={{
        paddingRight: '35px',
        flex: 1,
        [mediaQueries.phoneOnly]: {
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        },
        [mediaQueries.desktopUp]: {
          position: 'sticky',
          top: 0,
        },
      }}
    >
      <LogoLeReacteurLanding />

      <SectionSubtitle
        css={{
          [mediaQueries.phoneOnly]: {
            textAlign: 'center',
          },
        }}
      >
        {fromPage !== 'rncp6-alternance' && `Votre avenir commence ici.\n`}
        {programFiltered.title}
      </SectionSubtitle>

      {programFiltered.tags && (
        <TagContainer
          landing
          css={{ padding: '20px 0', [mediaQueries.phoneOnly]: { padding: '20px 0 10px 0' } }}
        >
          <Tag color="purpleDark" spacer home>
            {programFiltered.tags[0]}
          </Tag>
          <Tag color="yellow" spacer home>
            {programFiltered.tags[1]}
          </Tag>
          <Tag color="lightGrey" home>
            {programFiltered.tags[2]}
          </Tag>
        </TagContainer>
      )}

      {programFiltered.bullets && <BulletsPoints h3 content={programFiltered.bullets} />}

      {fromPage === 'reunion' && (
        <Paragraph
          css={{
            textAlign: 'start',
            [mediaQueries.phoneOnly]: {
              textAlign: 'center',
            },
          }}
        >
          Comment trouver la formation qui vous correspond vraiment&nbsp;?<br></br>
          Le Reacteur est la{' '}
          <strong css={{ color: colors.yellow }}>1ère&nbsp;formation&nbsp;intensive</strong>{' '}
          au&nbsp;Développement&nbsp;Web&nbsp;&&nbsp;Mobile créée&nbsp;en&nbsp;France.
          <br></br>
          <br></br>
          Participez à notre réunion d’information et posez-nous toutes&nbsp;vos&nbsp;questions.
        </Paragraph>
      )}

      {fromPage === 'rncp6-alternance' && (
        <Paragraph
          css={{
            paddingBottom: 10,
            textAlign: 'start',
            [mediaQueries.phoneOnly]: {
              textAlign: 'center',
            },
          }}
        >
          Après 10&nbsp;semaines de Bootcamp intensif (en&nbsp;présentiel ou à&nbsp;distance), vous
          alternerez entre périodes en entreprise de 3&nbsp;semaines et sessions de formation
          avancée pendant 1&nbsp;semaine, à&nbsp;distance, via&nbsp;Zoom.
        </Paragraph>
      )}
      <SocialProof data={programFiltered.socialProof} />
    </div>
  );
};
export default HeroText;
